import drawerStyles from "../../styles/drawer.module.css";
import Overlay from "../UI/Overlay";
import { ReactComponent as CloseIcon } from "../../assets/icons/x_black.svg";

const Drawer = ({
  children,
  onClose,
  heading,
}: {
  children: React.ReactNode | React.ReactNode[];
  onClose: () => void;
  heading: string;
}) => {
  return (
    <Overlay clickAway={onClose}>
      <div
        className={drawerStyles.drawer}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {heading && (
          <div className="flex justify-between items-center">
            <h1 style={{ font: "var(--font-h1)" }}>{heading}</h1>
            <CloseIcon onClick={onClose} cursor="pointer" />
          </div>
        )}
        {children}
      </div>
    </Overlay>
  );
};

export default Drawer;
